module.exports = __webpack_public_path__ + "static/placeholder-hero-fe35e2ac9e1bb1f67fc37cdff2399c7f.png";